import React from 'react';
import { FormRadio, Text, spacer8 } from '@spotify-internal/encore-web';

import { useTranslation } from 'providers/translations/TranslationProvider';

import { ReasonKey } from '../../hooks/useSubmitReason';

interface Reason {
  key: ReasonKey;
  title: string;
}

interface ReasonSelectorProps {
  selected?: ReasonKey;
  onSelect: (value: ReasonKey) => void;
}

const ReasonSelector = ({ selected, onSelect }: ReasonSelectorProps) => {
  const { t } = useTranslation();

  const reasons: Reason[] = [
    {
      key: 'did_not_answer',
      title: t('feedback_widget_option_did_not_answer'),
    },
    {
      key: 'did_not_work',
      title: t('feedback_widget_option_did_not_work'),
    },
    {
      key: 'confusing',
      title: t('feedback_widget_option_confusing'),
    },
    {
      key: 'broken_content',
      title: t('feedback_widget_option_broken_content'),
    },
    {
      key: 'other',
      title: t('feedback_widget_option_other'),
    },
  ];

  return (
    <div role="group" aria-labelledby="reason-selector_label" aria-live="polite">
      <Text id="reason-selector_label" as="p" variant="bodySmall" paddingBottom={spacer8}>
        {t('feedback_widget_let_us_know')}
      </Text>
      {reasons.map(reason => (
        <FormRadio
          key={reason.key}
          id={`reason-selector_${reason.key}`}
          data-testid={`reason-selector_${reason.key}`}
          name="reason-selector"
          checked={selected === reason.key}
          onChange={() => onSelect(reason.key)}
        >
          {reason.title}
        </FormRadio>
      ))}
    </div>
  );
};

export default ReasonSelector;
